import { getCookie } from "@workspace/cookies/browser";

const getGraphqlEndpoint = () => {
  const previewLink = getCookie("preview_gateway");
  return previewLink ?? `${location.origin}/graphql`;
};
export default getGraphqlEndpoint;
